export default {
    getCustomerContacts: { method: 'get', url: 'emcadmin/customers/contacts' },
    postCustomerContacts: { method: 'post', url: 'emcadmin/customers/contacts' },
    putCustomerContacts: { method: 'put', url: 'emcadmin/customers/contacts/{id}' },
    deleteCustomerContacts: { method: 'delete', url: 'emcadmin/customers/contacts/{id}' },
}
